<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>
<template>
  <div v-if="container">
    <h1 class="page-title">
      <i class="fa-solid fa-container-storage"></i
      ><span class="space-icon"></span>
      {{ show_container_code ? container?.container_code : "Contenedor" }}
    </h1>
    <div :class="show_panel ? 'panel' : ''">
      <div class="panel-body">
        <div class="divide-slate-200">
          <div class="grid grid-cols-1 gap-y-8 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.container.week") }}
              </dt>
              <dd class="content-data">
                {{ container?.week }}
              </dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.container.load_date") }}
              </dt>
              <dd class="content-data">
                {{ dateFormatter(container?.load_date) }}
              </dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.container.packing_house") }}:
              </dt>
              <dd class="content-data">{{ container?.packing_house_names.join(", ") }}</dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="label-data">{{ $t("model.container.customer") }}:</dt>
              <dd class="content-data">{{ container?.customer?.name }}</dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.container.exporter_process_crop_category") }}
              </dt>
              <dd class="content-data">
                {{ container?.category_name }}
              </dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.container.exporter_process_crop_variety") }}
              </dt>
              <dd class="content-data">
                {{ container?.variety_name }}
              </dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="label-data">
                {{ $t("model.container.exporter_process_brand") }}:
              </dt>
              <dd class="content-data">
                {{ container?.brand_name }}
              </dd>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReportingContainerInfo",
  props: {
    container: {
      type: Object,
      required: true
    },
    show_container_code: {
      type: Boolean,
      default: false
    },
    show_panel: {
      type: Boolean,
      default: true
    }
  }
};
</script>
